import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { MerchantStore } from '../stores/merchant.store';

@Injectable({
  providedIn: 'root'
})
export class PrivateAlertService {

  constructor(
    private alertController: AlertController, 
    private merchantStore: MerchantStore) {}

  async showPrivateAppAlert(
    navigate?: () => void
  ) {
    const subscriptionGroups = this.merchantStore.getSubGroups();
    const hasMemberships = Array.isArray(subscriptionGroups) && subscriptionGroups.length > 0;

    const alert = await this.alertController.create({
      header: 'Private App',
      message: hasMemberships
        ? 'This app is for members only. Please subscribe to access the app.'
        : 'Sorry, this app is private. Please contact the restaurant for more information.',
      backdropDismiss: false,
      keyboardClose: false,
      buttons: hasMemberships
        ? [
            {
              text: 'View Subscriptions',
              handler: () => {
                this.alertController.dismiss();
                navigate?.();
              }
            }
          ]
        : []
    });

    await alert.present();
  }
}
